import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import "./App.css";
import { Routes, Route, useLocation, Link } from "react-router-dom";
//import About from "./About";
import Contact from "./Contact";
import SiteNav from "./SiteNav";
import BuyButton from "./buybutton";
import FAQ1 from "./faq1";
import Science from "./Science";
import Checkout from "./Checkout";
//import Shop from "./shop";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/* -------- Smoothly handle /#anchors when navigating between routes -------- */
function ScrollAndHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

/* ----------------------------- HOME PAGE UI ------------------------------ */
function Home() {
  const root = useRef(null);

  // Pinned scrub video
  const pinSectionRef = useRef(null);
  const videoRef = useRef(null);
  const [videoReady, setVideoReady] = useState(false);

  // Horizontal flavours rail
  const hSectionRef = useRef(null);
  const hTrackRef = useRef(null);

  // Sticky specs
  const specsRef = useRef(null);
  const [specIndex, setSpecIndex] = useState(1);

  // Feature Swap
  const fsRef = useRef(null);

  // Reviews
  const revRef = useRef(null);

  // Origin Story
  const storyRef = useRef(null);

  const gaugeRef = useRef(null);

  const shopRef = useRef(null);
const shopVideoRef = useRef(null);

const youRef = useRef(null); 
const oneRef = useRef(null);
const productV1 = { name: "Dope Shot", price: 39, image: "/StickerDopeShot.webp" };


useLayoutEffect(() => {
  


  const root = oneRef.current;
  if (!root) return;

  const ctx = gsap.context(() => {
    // Helper: Create a counting animation
    const animateCount = (el, finalValue, duration = 1.2, startValue = 1000) => {
      if (!el) return;
      
      const obj = { value: startValue };
      const tween = gsap.to(obj, {
        value: finalValue,
        duration: duration,
        ease: "power2.inOut",
        onUpdate: () => {
          el.textContent = Math.round(obj.value);
        }
      });

      return tween;
    };

    // Get our number elements
    const bottleNum = root.querySelector('[data-role="bottle"]');
    const caloriesNum = root.querySelector('[data-role="calories"]');
    const excusesNum = root.querySelector('[data-role="excuses"]');

    // Initial states - all panels hidden
    gsap.set(".ob-panel", { autoAlpha: 0 });
    
    
    // Timeline for the whole pinned section
    let autoScrollTween;
    
    const startAutoScroll = () => {
      // Calculate the distance to scroll (300% of viewport height as per the end value)
      const distance = window.innerHeight * 3;
      autoScrollTween = gsap.to(window, {
        scrollTo: { y: pinSectionRef.current.offsetTop + distance },
        duration: 8, // Adjust this value to control scroll speed
        ease: "none"
      });
    };

    const stopAutoScroll = () => {
      if (autoScrollTween) {
        autoScrollTween.kill();
      }
    };

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: root,
        start: "top top",
        end: "+=300%",
        scrub: 1,
        pin: true,
        anticipatePin: 1,
        onEnter: startAutoScroll,
        onLeave: stopAutoScroll,
        onEnterBack: stopAutoScroll,
        snap: {
          snapTo: [0, 0.25, 0.5, 0.75, 1],
          duration: 0.8,
          ease: "power2.out",
          inertia: false
        }
      }
    });

    const FADE_DURATION = 2; // Longer fade duration
    const COUNT_DURATION = 2; // Longer count duration
    const PANEL_EASE = "power2.inOut"; // Smoother easing
    const PANEL_SPACING = "+=2"; // More time between panels

    // Panel 1: "1 bottle" (counting down from 1000)
    tl.addLabel("bottleIn")
      .fromTo(".ob-panel--bottle", 
        { autoAlpha: 0, scale: 0.9 }, 
        { autoAlpha: 1, scale: 1, duration: FADE_DURATION, ease: PANEL_EASE }
      )
      .add(() => animateCount(bottleNum, 1, COUNT_DURATION, 1000), "<+=0.2")
      .addLabel("bottleStay", "+=1.5") // Extra hold time

    // Panel 2: "1200 calories" (counting up from 0)
    tl.addLabel("caloriesIn", PANEL_SPACING)
      .to(".ob-panel--bottle", { autoAlpha: 0, scale: 1.1, duration: FADE_DURATION })
      .fromTo(".ob-panel--calories", 
        { autoAlpha: 0, scale: 0.9 }, 
        { autoAlpha: 1, scale: 1, duration: FADE_DURATION, ease: PANEL_EASE }
      )
      .add(() => animateCount(caloriesNum, 1200, COUNT_DURATION, 0), "<+=0.2")
      .addLabel("caloriesStay", "+=1.5") // Extra hold time

    // Panel 3: "0 excuses" (counting down from 1000)
    tl.addLabel("excusesIn", PANEL_SPACING)
      .to(".ob-panel--calories", { autoAlpha: 0, scale: 1.1, duration: FADE_DURATION })
      .fromTo(".ob-panel--excuses", 
        { autoAlpha: 0, scale: 0.9 }, 
        { autoAlpha: 1, scale: 1, duration: FADE_DURATION, ease: PANEL_EASE }
      )
      .add(() => animateCount(excusesNum, 0, COUNT_DURATION, 1000), "<+=0.2")
      .addLabel("excusesStay", "+=1.5") // Extra hold time

    // Prep cinematic elements once
gsap.set(".ob-flash", { autoAlpha: 0 });
gsap.set(".ob-bars .top", { yPercent: -100 });
gsap.set(".ob-bars .bot", { yPercent: 100 });
gsap.set(".ob-shockwave", { autoAlpha: 0, scale: 0.2, transformOrigin: "50% 50%" });

// Panel 4: Final tagline — cinematic jump-scare
tl.addLabel("tagline", PANEL_SPACING)
  .to(".ob-panel--excuses", { autoAlpha: 0, scale: 1.1, duration: FADE_DURATION })

  // ⚡ impact moment
  .add("impact")

  // 1) White flash (very quick)
  .to(".ob-flash", { autoAlpha: 1, duration: 0.18, ease: "power4.out" }, "impact")
  .to(".ob-flash", { autoAlpha: 0, duration: 0.28, ease: "power2.out" }, ">")

  // 2) Letterbox bars snap in
  .to(".ob-bars .top", { yPercent: 0, duration: 0.28, ease: "power4.out" }, "impact")
  .to(".ob-bars .bot", { yPercent: 0, duration: 0.28, ease: "power4.out" }, "impact")

  // 3) Tagline appears with overshoot + deblur
  .fromTo(".ob-panel--tag",
    { autoAlpha: 0, scale: 0.72, filter: "blur(8px) contrast(1.25)" },
    { autoAlpha: 1, scale: 1.12, filter: "blur(0px) contrast(1)", duration: 0.38, ease: "back.out(2.2)" },
    "impact+=0.02"
  )
  .to(".ob-panel--tag", { scale: 1.0, duration: 0.32, ease: "power2.out" }, ">-0.04")

  // 4) Shockwave bloom
  .fromTo(".ob-shockwave",
    { autoAlpha: 0, scale: 0.3 },
    { autoAlpha: 1, scale: 2.3, duration: 1, ease: "power3.out" },
    "impact+=0.02"
  )
  .to(".ob-shockwave", { autoAlpha: 0, duration: 0.45, ease: "power2.out" }, "<+0.22")

  // 5) Camera shake (micro, feels tactile)
  .fromTo(".ob-stage",
    { x: 0, y: 0 },
    {
      duration: 0.45,
      keyframes: [
        { x: -6, y: -3, ease: "power2.out" },
        { x: 5,  y:  4, ease: "power2.out" },
        { x: -3, y:  2, ease: "power2.out" },
        { x: 0,  y:  0, ease: "power2.out" }
      ]
    },
    "impact+=0.02"
  )

  .addLabel("taglineStay", "+=2");


    // Subtle background motion tied to scroll velocity
    const proxy = { skew: 0 };
    const clamp = gsap.utils.clamp(-4, 4);
    ScrollTrigger.create({
      trigger: root,
      start: "top top",
      end: "bottom bottom",
      onUpdate: (self) => {
        const s = clamp(self.getVelocity() / -400);
        if (Math.abs(s) > Math.abs(proxy.skew)) {
          proxy.skew = s;
          gsap.to(proxy, { skew: 0, duration: 0.6, overwrite: true });
        }
      }
    });

    // refresh after media loads
    const onLoad = () => ScrollTrigger.refresh();
    window.addEventListener("load", onLoad);
    requestAnimationFrame(() => ScrollTrigger.refresh());

    return () => {
      window.removeEventListener("load", onLoad);
      tl.kill();
    };
  }, oneRef);

  return () => ctx.revert();
}, []);






  useLayoutEffect(() => {

  const wrap = shopRef.current;
  const vid = shopVideoRef.current;
  if (!wrap) return;

  const ctx = gsap.context(() => {
    // Section entrance
    gsap.from(".shop-dope-real .shop-kicker", {
      y: 24, opacity: 0, duration: 0.4, ease: "power2.out",
      scrollTrigger: { trigger: wrap, start: "top 92%" }
    });
    gsap.from(".shop-dope-real .shop-title", {
      y: 28, opacity: 0, duration: 0.5, ease: "power2.out", delay: 0.05,
      scrollTrigger: { trigger: wrap, start: "top 92%" }
    });
    gsap.from(".shop-dope-real .shop-sub", {
      y: 20, opacity: 0, duration: 0.4, ease: "power2.out", delay: 0.1,
      scrollTrigger: { trigger: wrap, start: "top 92%" }
    });

    // Video reveal (mask + scale settle)
    gsap.from(".shop-dope-real .media-frame", {
      clipPath: "inset(0 100% 0 0 round 12px)",
      duration: 0.6,
      ease: "power2.out",
      scrollTrigger: { trigger: wrap, start: "top 88%" }
    });
    gsap.from(".shop-dope-real .shop-video", {
      scale: 1.06, filter: "blur(3px) contrast(1.2) grayscale(0.3)",
      duration: 0.7, ease: "power2.out",
      scrollTrigger: { trigger: wrap, start: "top 88%" }
    });

    // Auto play/pause video as it enters/leaves view
    if (vid) {
      let playPromise = null;
      
      const safePlay = async () => {
        if (vid.paused) {
          try {
            playPromise = vid.play();
            if (playPromise !== undefined) {
              await playPromise;
            }
          } catch (error) {
            console.log("Video play interrupted");
          }
        }
      };

      const safePause = async () => {
        if (!vid.paused) {
          try {
            if (playPromise !== undefined) {
              await playPromise;
            }
            vid.pause();
          } catch (error) {
            console.log("Video pause interrupted");
          }
        }
      };

      ScrollTrigger.create({
        trigger: vid,
        start: "top 85%",
        end: "bottom 15%",
        onEnter: safePlay,
        onEnterBack: safePlay,
        
        /*onLeave: safePause,
        onLeaveBack: safePause*/
      });
    }

    // Feature list stagger
    gsap.from(".shop-dope-real .shop-features li", {
      y: 14, opacity: 0, duration: 0.4, ease: "power3.out",
      stagger: 0.08,
      scrollTrigger: { trigger: wrap, start: "top 72%" }
    });

    // Button micro pulse when in view
    gsap.fromTo(".shop-dope-real .shop-btn",
      { y: 0, boxShadow: "0 0 0 rgba(0,0,0,0)" },
      {
        y: -2,
        boxShadow: "0 10px 24px rgba(0,0,0,.35)",
        duration: 0.9,
        ease: "power2.out",
        repeat: -1, yoyo: true,
        scrollTrigger: { trigger: wrap, start: "top 70%", end: "bottom top", toggleActions: "play pause resume pause" }
      }
    );

    // Gloss sweep across video
    gsap.fromTo(".shop-dope-real .media-gloss",
      { xPercent: -120, opacity: 0 },
      {
        xPercent: 120, opacity: 1,
        duration: 1.6, ease: "power2.out",
        scrollTrigger: { trigger: wrap, start: "top 78%", once: true }
      }
    );

  }, wrap);

  // Dimensions chip entrance



  // safety refresh for media sizing
  const onLoad = () => ScrollTrigger.refresh();
  window.addEventListener("load", onLoad);

  return () => { window.removeEventListener("load", onLoad); ctx.revert(); };
}, []);




  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // HERO: bottom → bottom → left → logo zoom-out
      gsap.set([".hero-kicker", ".hero-sub"], { y: 18, autoAlpha: 0 });
      gsap.set(".h-line", { autoAlpha: 0 });
      gsap.set(".l1, .l2", { y: 40 });       // from bottom
      gsap.set(".l3", { x: -40 });           // from left
      gsap.set(".hero-logo", {               // start small + blurred
        scale: 0.6,
        y: 10,
        autoAlpha: 0,
        filter: "blur(6px)",
        transformOrigin: "50% 50%"
      });

      // optional: bring in kicker/sub softly
      gsap.to(".hero-kicker", { y: 0, autoAlpha: 1, duration: 0.6, ease: "power3.out", delay: 0.05 });
      gsap.to(".hero-sub",    { y: 0, autoAlpha: 1, duration: 0.6, ease: "power3.out", delay: 0.55 });

      const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

      tl.to(".l1", { y: 0, autoAlpha: 1, duration: 0.6 }, "+=0.55")           // 1) up from bottom
        .to(".l2", { y: 0, autoAlpha: 1, duration: 0.6 }, "+=0.05") // 2) up from bottom
        .to(".l3", { x: 0, autoAlpha: 1, duration: 0.6 })           // 3) from left
        // 4) logo zoom-out + deblur + gentle pop
        .to(".hero-logo", {
          scale: 1,
          y: 0,
          autoAlpha: 1,
          filter: "blur(0px)",
          duration: 0.9,
          //ease: "back.out(1.6)"
        })
  
        .to(".hero-logo", { scale: 1, duration: 0.26, ease: "power4.out" });


        //gsap.fromTo(".hero-cta", { y: 20, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.6, ease: "power3.out", delay: 1.4 });


      // Marquee nudge
      gsap.to(".marquee-track", {
        xPercent: -30,
        ease: "none",
        scrollTrigger: {
          trigger: ".marquee",
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });

      // Reveal-ups
      gsap.utils.toArray(".reveal-up").forEach(el => {
        gsap.from(el, {
          y: 40,
          opacity: 0,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        });
      });

      // Parallax cards
      gsap.utils.toArray(".card").forEach(card => {
        const img = card.querySelector("img");
        gsap.to(img, {
          yPercent: -12,
          ease: "none",
          scrollTrigger: {
            trigger: card,
            start: "top bottom",
            end: "bottom top",
            scrub: true
          }
        });
      });

      // Grid entrance
    gsap.utils.toArray(".grid .card").forEach((card, i) => {
      gsap.from(card, {
        x: i % 2 ? 80 : -80,     // even: left, odd: right
        y: 20,
        opacity: 0,
        rotate: i % 2 ? 1.2 : -1.2,
        duration: 0.9,
        ease: "power3.out",
        scrollTrigger: { trigger: ".grid", start: "top 80%", once: true }
      });
    });

      // Footer
      gsap.from(".site-footer a", {
        opacity: 0,
        y: 12,
        stagger: 0.08,
        duration: 0.6,
        ease: "power3.out",
        scrollTrigger: { trigger: ".site-footer", start: "top 85%" }
      });

      // BIG BREAK
      gsap.from(".breaker-word", {
        y: 60,
        rotateX: 40,
        opacity: 0,
        transformOrigin: "50% 100%",
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.06,
        scrollTrigger: { trigger: ".big-break", start: "top 75%", once: true }
      });
      gsap.to(".breaker-line", {
        letterSpacing: "0.02em",
        scale: 1.02,
        scrollTrigger: { trigger: ".big-break", start: "top bottom", end: "bottom top", scrub: true }
      });
      gsap.fromTo(".breaker-rule .rule-inner",
        { width: "0%" },
        {
          width: "100%",
          duration: 0.9,
          ease: "power2.out",
          scrollTrigger: { trigger: ".big-break", start: "top 85%", once: true }
        }
      );
      gsap.from(".breaker-tag", {
        y: 16,
        autoAlpha: 0,
        scale: 0.98,
        duration: 0.6,
        ease: "power3.out",
        scrollTrigger: { trigger: ".big-break", start: "top 65%", once: true }
      });

      window.addEventListener("load", () => ScrollTrigger.refresh());
    }, root);

    return () => ctx.revert();
  }, []);

  // Pinned video scrub + storyboard
  {/*
  useLayoutEffect(() => {
    const section = pinSectionRef.current;
    const video = videoRef.current;
    if (!section || !video) return;

    // Set up video for continuous background playback
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.autoplay = true;
    video.playbackRate = 1;
    video.setAttribute("playsinline", "");
    video.setAttribute("webkit-playsinline", "");
    video.setAttribute("loop", "");
    video.setAttribute("autoplay", "");
    video.preload = "auto";
    
    // Style video for background
    video.style.objectFit = "cover";
    video.style.width = "100%";
    video.style.height = "100%";
    video.style.position = "absolute";
    video.style.top = "0";
    video.style.left = "0";
    video.style.zIndex = "1";

    // Force video to play
    setInterval(() => {
      if (video.paused) {
        video.play().catch(() => {});
      }
    }, 1000);

    const ctx = gsap.context(() => {
      const ANIMATION_DURATION = 4; // Total duration for the entire sequence
      const SECTIONS = 4; // Number of text sections
      
      // Set initial state for all text elements
      gsap.set(".scrub-text", { autoAlpha: 0, y: 40 });
      
      // Create master timeline for text animations
      const textTimeline = gsap.timeline({ paused: true });
      
      // Add text animations to the timeline
      const textDuration = ANIMATION_DURATION / SECTIONS;
      
      textTimeline
        .to(".t-1", { 
          autoAlpha: 1, 
          y: 0, 
          duration: textDuration * 0.4,
          ease: "power2.out"
        })
        .to(".t-1", { 
          autoAlpha: 0, 
          y: -40,
          duration: textDuration * 0.3
        }, `+=${textDuration * 0.3}`)
        .to(".t-2", { 
          autoAlpha: 1, 
          y: 0, 
          duration: textDuration * 0.4,
          ease: "power2.out"
        }, "-=0.3")
        .to(".t-2", { 
          autoAlpha: 0, 
          y: -40,
          duration: textDuration * 0.3
        }, `+=${textDuration * 0.3}`)
        .to(".t-3", { 
          autoAlpha: 1, 
          y: 0, 
          duration: textDuration * 0.4,
          ease: "power2.out"
        }, "-=0.3")
        .to(".t-3", { 
          autoAlpha: 0, 
          y: -40,
          duration: textDuration * 0.3
        }, `+=${textDuration * 0.3}`)
        .to(".t-4", { 
          autoAlpha: 1, 
          y: 0, 
          duration: textDuration * 0.4,
          ease: "power2.out"
        }, "-=0.3");

      // Variables to track animation state
      let autoScrollTween;
      let videoTween;
      let scrollProgress = 0;
      
      const startAutoScroll = () => {
        if (autoScrollTween) return; // Prevent multiple instances
        
        const scrollDistance = window.innerHeight * 3; // Use viewport height for consistent scrolling
        scrollProgress = 0;
        
        // Create the auto-scroll animation
        autoScrollTween = gsap.to(window, {
          duration: ANIMATION_DURATION,
          scrollTo: {
            y: section.offsetTop + scrollDistance,
            autoKill: false
          },
          ease: "none",
          onUpdate: function() {
            if (this.progress) {
              scrollProgress = this.progress();
              textTimeline.progress(scrollProgress);
            }
          },
          onComplete: () => {
            stopAutoScroll();
          }
        });
      };

      const stopAutoScroll = () => {
        // Kill scroll animation
        if (autoScrollTween) {
          autoScrollTween.kill();
          autoScrollTween = null;
        }
        
        // Don't stop the video, let it play in the background
        // Just reset the animation progress
        scrollProgress = 0;
      };

      // Initialize video
      const initVideo = () => {
        video.currentTime = 0;
        video.muted = true;
        video.playsInline = true;
        return Promise.resolve();
      };

      // Initial video setup
      initVideo();

      // Start video playing immediately
      video.play().then(() => {
        console.log("Video started playing");
      }).catch(() => {
        console.log("Video autoplay prevented");
      });

      const st = ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: "+=300%",
        pin: true,
        pinSpacing: true,
        pinReparent: true,
        anticipatePin: 1,
        scrub: 1,
        onEnter: () => {
          // Ensure video is playing when entering section
          if (video.paused) {
            video.play().catch(() => {});
          }
          startAutoScroll();
        },
        onEnterBack: stopAutoScroll,
        onLeave: () => {
          stopAutoScroll();
          // Don't pause the video when leaving
        },
        onLeaveBack: stopAutoScroll,
        snap: {
          snapTo: [0, 0.33, 0.67, 1],
          duration: 0.3,
          ease: "power1.inOut"
        },
        refreshPriority: 100,
        onUpdate: self => {
          const dur = video.duration || 1;
          const t = self.progress * dur;
          if (!Number.isNaN(t) && Number.isFinite(t)) {
            try { video.currentTime = t; } catch {}
          }
          textTimeline.progress(self.progress);
        },
        onRefresh: () => textTimeline.progress(0),
        invalidateOnRefresh: true
      });

      const onMeta = () => {
        setVideoReady(true);
        ScrollTrigger.refresh();
        video.removeEventListener("loadedmetadata", onMeta);
      };
      if (video.readyState >= 1) onMeta();
      else video.addEventListener("loadedmetadata", onMeta);

      return () => st.kill();
    }, section);

    return () => ctx.revert();
  }, []);*/}

 // Pinned scrub + storyboard — video loops; text auto-plays; releases past end
useLayoutEffect(() => {
  const section = pinSectionRef.current;
  const video   = videoRef.current;
  if (!section || !video) return;

  // keep background video alive
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.preload = "metadata";
  video.setAttribute("playsinline", "");
  video.setAttribute("muted", "");
  video.setAttribute("loop", "");
  const ensurePlay = () => { if (video.paused) video.play().catch(() => {}); };
  ensurePlay();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") ensurePlay();
  }, { passive: true });
  window.addEventListener("pointerdown", ensurePlay, { once: true, passive: true });

  // layering
  const q = gsap.utils.selector(section);
  gsap.set(q(".video"), { position:"absolute", inset:0, width:"100%", height:"100%", objectFit:"cover", zIndex:1, pointerEvents:"none" });
  gsap.set(q(".scrub-overlay"), { position:"relative", zIndex:2 });

  // storyboard timeline
  gsap.set(q(".scrub-text"), { autoAlpha: 0, y: 20 }); // Reduced initial offset
  const tl = gsap.timeline({ paused: true, defaults: { ease: "power1.out" } }); // Faster ease
  const IN  = { autoAlpha: 1, y: 0,   duration: 0.3 }; // Faster in animation
  const OUT = { autoAlpha: 0, y: -20, duration: 0.2 }; // Faster out animation

  tl.to(q(".t-1"), IN)
    .to(q(".t-1"), OUT, "+=0.3") // Shorter delay between transitions
    .to(q(".t-2"), IN, "-=0.1")  // More overlap for smoother transition
    .to(q(".t-2"), OUT, "+=0.3")
    .to(q(".t-3"), IN, "-=0.1")
    .to(q(".t-3"), OUT, "+=0.3")
    .to(q(".t-4"), IN, "-=0.1");

  const TOTAL_TIME = 4;     // Reduced to 4 seconds for faster text animation
  let autoTween = null;
  let resumeTO  = null;
  let autoDone  = false;

  const stopAuto = () => {
    if (autoTween) { autoTween.kill(); autoTween = null; }
  };
  const clearResume = () => {
    if (resumeTO) { clearTimeout(resumeTO); resumeTO = null; }
  };

  const st = ScrollTrigger.create({
    trigger: section,
    start: "top top",
    end: "+=" + Math.max(window.innerHeight * 1.5, 800), // Reduced scroll distance
    pin: true,
    pinSpacing: true,
    scrub: 0.5, // Faster scrub response
    anticipatePin: 1,
    onUpdate: self => {
      tl.progress(self.progress);          // drive text by scroll
      if (video.paused) ensurePlay();      // keep bg video alive
    },
    onRefreshInit: () => {                 // reset on layout changes
      autoDone = false;
      stopAuto();
    },
    onRefresh: () => tl.progress(0),
    invalidateOnRefresh: true
  });

  // Auto-scroll from current spot to just past the pin end
  const resumeAuto = (minDuration = 0.6) => {
    if (autoDone || !st || !st.isActive) return;

    const progress = st.progress;
    if (progress >= 0.99) {
      // already at end — push slightly past to release pin, then stop
      autoDone = true;
      stopAuto();
      gsap.to({ y: window.scrollY }, {
        y: st.end + 2,
        duration: 0.35,
        ease: "power2.out",
        onUpdate: function () { window.scrollTo(0, this.targets()[0].y); }
      });
      return;
    }

    const endY = st.end - 4; // stop just inside, we'll push past onComplete
    const proxy = { y: window.scrollY };
    const remaining = Math.max(TOTAL_TIME * (1 - progress), minDuration);

    stopAuto();
    autoTween = gsap.to(proxy, {
      y: endY,
      duration: remaining,
      ease: "none",
      onUpdate: () => window.scrollTo(0, proxy.y),
      onComplete: () => {
        autoTween = null;
        autoDone = true;
        // nudge past the end to unpin so the next section becomes scrollable
        gsap.to({ y: window.scrollY }, {
          y: st.end + 2,
          duration: 0.35,
          ease: "power2.out",
          onUpdate: function () { window.scrollTo(0, this.targets()[0].y); }
        });
      }
    });
  };

  // (re)start auto when entering
  st.vars.onEnter = () => { autoDone = false; resumeAuto(); };
  st.vars.onEnterBack = () => { autoDone = false; /* don't auto-trap on upward scroll */ };
  st.vars.onLeave = () => { stopAuto(); clearResume(); };
  st.vars.onLeaveBack = () => { stopAuto(); clearResume(); };
  st.refresh();

  // If user scrolls/gestures/keys inside, allow it, then resume (unless finished)
  const scheduleResume = () => {
    if (autoDone || !st.isActive) return;
    clearResume();
    resumeTO = setTimeout(() => resumeAuto(0.5), 140);
  };
  const keyWhitelist = new Set([" ", "PageDown", "PageUp", "ArrowDown", "ArrowUp", "Home", "End"]);

  const onWheel = () => scheduleResume();
  const onTouchMove = () => scheduleResume();
  const onKeyDown = (e) => { if (keyWhitelist.has(e.key)) scheduleResume(); };

  section.addEventListener("wheel", onWheel, { passive: true });
  section.addEventListener("touchmove", onTouchMove, { passive: true });
  window.addEventListener("keydown", onKeyDown, { passive: true });

  // If we landed mid-section, kick auto once
  if (ScrollTrigger.isInViewport(section, 0.99)) resumeAuto();

  const onLoad = () => ScrollTrigger.refresh();
  window.addEventListener("load", onLoad);

  return () => {
    stopAuto();
    clearResume();
    section.removeEventListener("wheel", onWheel);
    section.removeEventListener("touchmove", onTouchMove);
    window.removeEventListener("keydown", onKeyDown);
    window.removeEventListener("load", onLoad);
    st.kill();
  };
}, []);



  // Horizontal flavours rail
  /*
  useLayoutEffect(() => {
    const section = hSectionRef.current;
    const track = hTrackRef.current;
    if (!section || !track) return;

    const ctx = gsap.context(() => {
      const getWidth = () => track.scrollWidth - window.innerWidth;
      gsap.to(track, {
        x: () => -getWidth(),
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "top top",
          end: () => "+=" + Math.max(1200, getWidth()),
          pin: true,
          scrub: true,
          anticipatePin: 1,
          refreshPriority: 90,
          invalidateOnRefresh: true
        }
      });
      requestAnimationFrame(() => ScrollTrigger.refresh());
    }, section);

    return () => ctx.revert();
  }, []);*/

  // Sticky specs scrollytelling
  /*
  useLayoutEffect(() => {
    const wrap = specsRef.current;
    if (!wrap) return;

    const ctx = gsap.context(() => {
      const panels = gsap.utils.toArray(".spec-panel");
      panels.forEach((panel, i) => {
        gsap.from(panel, {
          opacity: 0,
          y: 40,
          duration: 0.6,
          ease: "power3.out",
          scrollTrigger: {
            trigger: panel,
            start: "top 70%",
            toggleActions: "play none none reverse"
          }
        });

        ScrollTrigger.create({
          trigger: panel,
          start: "top center",
          onEnter: () => setSpecIndex(i + 1),
          onEnterBack: () => setSpecIndex(i + 1)
        });
      });
    }, wrap);

    return () => ctx.revert();
  }, []);
*/

  // Feature Swap
  {/*}
  useLayoutEffect(() => {
    const wrap = fsRef.current;
    if (!wrap) return;

    const ctx = gsap.context(() => {
      const steps = gsap.utils.toArray(".fs-step");
      const imgs = gsap.utils.toArray(".fs-img");

      gsap.set(imgs, { autoAlpha: 0 });
      if (imgs[0]) gsap.set(imgs[0], { autoAlpha: 1 });

      const setActive = i => {
        gsap.to(imgs, { autoAlpha: 0, duration: 0.35, overwrite: true });
        gsap.to(imgs[i], { autoAlpha: 1, duration: 0.5, ease: "power2.out", overwrite: true });
        gsap.to(".fs-bar", { width: ((i + 1) / steps.length) * 100 + "%", duration: 0.3, ease: "power2.out" });
      };

      steps.forEach((step, i) => {
        ScrollTrigger.create({
          trigger: step,
          start: "top 55%",
          onEnter: () => setActive(i),
          onEnterBack: () => setActive(i)
        });
        gsap.from(step, {
          y: 24,
          opacity: 0,
          duration: 0.6,
          ease: "power3.out",
          scrollTrigger: {
            trigger: step,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        });
      });

      ScrollTrigger.create({
        trigger: ".feature-swap",
        start: "top top",
        end: "bottom bottom",
        pin: ".fs-sticky",
        pinSpacing: false,
        anticipatePin: 1
      });
    }, wrap);

    return () => ctx.revert();
  }, []);

  // Reviews entrance
  useLayoutEffect(() => {
    const wrap = revRef.current;
    if (!wrap) return;

    const ctx = gsap.context(() => {
      gsap.utils.toArray(".review").forEach(card => {
        gsap.fromTo(card, { scale: 0.96, opacity: 0.8 }, {
          scale: 1,
          opacity: 1,
          duration: 0.6,
          ease: "power2.out",
          scrollTrigger: { trigger: card, start: "top 90%" }
        });
      });
    }, wrap);

    return () => ctx.revert();
  }, []);*/}

  // Feature Swap — autoplay every 2s (no scroll needed to change images)

{/*}
useLayoutEffect(() => {
  const wrap = fsRef.current;
  if (!wrap) return;

  const ctx = gsap.context(() => {
    const steps = gsap.utils.toArray(".fs-step");
    const imgs  = gsap.utils.toArray(".fs-img");

    // initial vis
    gsap.set(imgs,  { autoAlpha: 0 });
    if (imgs[0]) gsap.set(imgs[0], { autoAlpha: 1 });
    gsap.set(steps, { opacity: 0.6 });
    if (steps[0]) gsap.set(steps[0], { opacity: 1 });

    const setActive = (i) => {
      // cross-fade images
      gsap.to(imgs,    { autoAlpha: 0, duration: 0.35, overwrite: true });
      gsap.to(imgs[i], { autoAlpha: 1, duration: 0.5, ease: "power2.out", overwrite: true });

      // progress + bullet emphasis
      const total = Math.max(imgs.length, 1);
      gsap.to(".fs-bar", { width: ((i + 1) / total) * 100 + "%", duration: 0.35, ease: "power2.out" });
      gsap.to(steps,     { opacity: 0.6, duration: 0.2, overwrite: true });
      if (steps[i]) gsap.to(steps[i], { opacity: 1, duration: 0.2, overwrite: true });
    };

    // autoplay timeline: change slide every 2s
    setActive(0);
    const tl = gsap.timeline({ repeat: -1 });
    imgs.forEach((_, i) => {
      tl.call(setActive, [i]).to({}, { duration: 1.5 }); // wait 2s before advancing
    });

    // nice reveal on first view
    gsap.from(steps, {
      y: 4, opacity: 0, duration: 0.6, ease: "power3.out", stagger: 0.08,
      scrollTrigger: { trigger: wrap, start: "top 80%", once: true }
    });

    // keep the sticky aside

    ScrollTrigger.create({
      trigger: ".feature-swap",
      start: "top top",
      end: "bottom bottom",
      pin: ".fs-sticky",
      pinSpacing: false,
      anticipatePin: 1
    });


    return () => {
 
      tl.kill();
    };
  }, wrap);

  return () => ctx.revert();
}, []);*/}

  

/* ===== ABOUT-THAT (v4) animations ===== 
const AT4 = ".about-that.v4";

// Initial states
gsap.set(`${AT4} .at4-line`, { autoAlpha: 0, y: 26 });
gsap.set(`${AT4} .ph`, { autoAlpha: 0, scale: 0.92, rotate: () => gsap.utils.random(-8, 8), clipPath: "circle(0% at 50% 50%)" });
gsap.set(`${AT4} .ph img`, { scale: 1.08 });
gsap.set(`${AT4} .at4-rule .inner`, { width: "0%" });

// Text reveal
gsap.to(`${AT4} .at4-line`, {
  y: 0, autoAlpha: 1, duration: 0.7, ease: "power3.out", stagger: 0.12,
  scrollTrigger: { trigger: AT4, start: "top 78%", once: true }
});

// Underline grow
gsap.to(`${AT4} .at4-rule .inner`, {
  width: "100%", duration: 0.8, ease: "power2.out",
  scrollTrigger: { trigger: AT4, start: "top 76%", once: true }
});

// Photo constellation pop-in (randomized order)
gsap.to(`${AT4} .ph`, {
  autoAlpha: 1,
  clipPath: "circle(75% at 50% 50%)",
  scale: 1,
  rotate: 0,
  duration: 0.72,
  ease: "power3.out",
  stagger: { each: 0.08, from: "random" },
  scrollTrigger: { trigger: `${AT4} .at4-collage`, start: "top 85%", once: true }
});

// Subtle parallax of the collage
gsap.to(`${AT4} .at4-collage`, {
  yPercent: -8, ease: "none",
  scrollTrigger: { trigger: AT4, start: "top bottom", end: "bottom top", scrub: true }
});

// Continuous floating drift per photo
/*document.querySelectorAll(`${AT4} .ph`).forEach((el) => {
  const r = gsap.utils.random;
  gsap.to(el, {
    x: r(-14, 14),
    y: r(-16, 16),
    rotate: r(-2.5, 2.5),
    duration: r(3.5, 5.5),
    ease: "sine.inOut",
    repeat: -1,
    yoyo: true
    /*x: r(-8, 8), y: r(-10, 10), rotate: r(-2, 2),
    duration: r(3, 5), ease: "sine.inOut", repeat: -1, yoyo: true
  });
});

// Glow shimmer loop
gsap.to(`${AT4} .at4-glow`, {
  backgroundPosition: "120% 50%",
  duration: 4.5,
  ease: "none",
  repeat: -1
});

// Magnetic tilt on hover
(() => {
  const stage = document.querySelector(`${AT4} .at4-stage`);
  if (!stage) return;
  const qx = gsap.quickTo(stage, "rotateX", { duration: 0.4, ease: "power2.out" });
  const qy = gsap.quickTo(stage, "rotateY", { duration: 0.4, ease: "power2.out" });
  const qz = gsap.quickTo(stage, "translateZ", { duration: 0.4, ease: "power2.out" });

  const move = (e) => {
    const r = stage.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    qx(gsap.utils.clamp(-6, 6, (0.5 - y) * 14));
    qy(gsap.utils.clamp(-6, 6, (x - 0.5) * 16));
    qz(10);
  };
  const leave = () => { qx(0); qy(0); qz(0); };

  stage.addEventListener("mousemove", move);
  stage.addEventListener("mouseleave", leave);
})();
*/

/* 
  // Origin Story sticky cross-fade
  useLayoutEffect(() => {
    const wrap = storyRef.current;
    if (!wrap) return;

    const ctx = gsap.context(() => {
      const steps = gsap.utils.toArray(".story-step");
      const imgs = gsap.utils.toArray(".story-img");

      gsap.set(imgs, { autoAlpha: 0 });
      if (imgs[0]) gsap.set(imgs[0], { autoAlpha: 1 });

      const setActive = i => {
        gsap.to(imgs, { autoAlpha: 0, duration: 0.35, overwrite: true });
        gsap.to(imgs[i], { autoAlpha: 1, duration: 0.5, ease: "power2.out", overwrite: true });
      };

      steps.forEach((step, i) => {
        ScrollTrigger.create({
          trigger: step,
          start: "top 55%",
          onEnter: () => setActive(i),
          onEnterBack: () => setActive(i)
        });
        gsap.from(step, {
          y: 24,
          opacity: 0,
          duration: 0.6,
          ease: "power3.out",
          scrollTrigger: { trigger: step, start: "top 80%" }
        });
      });

      ScrollTrigger.create({
        trigger: ".origin",
        start: "top top",
        end: "bottom bottom",
        pin: ".story-sticky",
        pinSpacing: false,
        anticipatePin: 1
      });
    }, wrap);

    return () => ctx.revert();
  }, []);

  // FAQ (single-open)
  useEffect(() => {
    const items = Array.from(document.querySelectorAll(".faq-item"));
    const cleanups = [];

    const openItem = (target) => {
      items.forEach(it => {
        const content = it.querySelector(".faq-a");
        const icon = it.querySelector(".faq-icon");
        const btn = it.querySelector(".faq-q");
        const isOpen = it === target && !it.classList.contains("open");
        if (isOpen) {
          it.classList.add("open");
          btn.setAttribute("aria-expanded", "true");
          gsap.to(content, { height: content.scrollHeight, duration: 0.35, ease: "power2.out" });
          gsap.to(icon, { rotate: 45, duration: 0.25, ease: "power2.out" });
        } else {
          it.classList.remove("open");
          btn.setAttribute("aria-expanded", "false");
          gsap.to(content, { height: 0, duration: 0.35, ease: "power2.inOut" });
          gsap.to(icon, { rotate: 0, duration: 0.25, ease: "power2.out" });
        }
      });
    };

    items.forEach((item, idx) => {
      const btn = item.querySelector(".faq-q");
      const content = item.querySelector(".faq-a");
      gsap.set(content, { height: 0, overflow: "hidden" });
      const handler = () => openItem(item);
      btn.addEventListener("click", handler);
      cleanups.push(() => btn.removeEventListener("click", handler));
      if (idx === 0) requestAnimationFrame(() => openItem(item));
    });

    return () => cleanups.forEach(fn => fn());
  }, []);

  // Counters (owner impact)
  useEffect(() => {
    const counters = document.querySelectorAll("[data-count]");
    counters.forEach(el => {
      const end = parseInt(el.getAttribute("data-count") || "0", 10);
      const obj = { val: 0 };
      gsap.to(obj, {
        val: end,
        duration: 1.4,
        ease: "power2.out",
        scrollTrigger: { trigger: el, start: "top 85%" },
        onUpdate: () => { el.textContent = Math.round(obj.val).toString(); }
      });
    });
  }, []);

  useLayoutEffect(() => {
    const root = gaugeRef.current;
    if (!root) return;

    const ctx = gsap.context(() => {
      const arcFill  = root.querySelector("#ga-arc-fill");
      const needle   = root.querySelector(".ga-needle");
      const readout  = root.querySelector(".ga-val");
      const s1       = root.querySelector(".ga-state.s1");
      const s2       = root.querySelector(".ga-state.s2");
      const bottle   = root.querySelector(".ga-bottle");

      // semicircle geometry helpers
      const CX = 160, CY = 160, R = 120;
      const ANG = (v) => -90 + v * 1.8; // 0..100 -> -90..+90

      // path length with safe fallback
      let len = Math.PI * R;
      try { len = arcFill.getTotalLength() || len; } catch {}

      // prep
      gsap.set(arcFill, { strokeDasharray: len, strokeDashoffset: len });
      gsap.set(needle, { rotation: -90, transformOrigin: `${CX}px ${CY}px` });
      gsap.set([s1, s2], { autoAlpha: 0, y: 8 });
      gsap.set(bottle, { autoAlpha: 0, scale: 0.6, transformOrigin: "50% 100%" });
      const counter = { v: 0 };

      // timeline (PAUSED) — we’ll play it when in view
      const tl = gsap.timeline({ paused: true, defaults: { ease: "power3.out" } });

      tl.from(root.querySelector(".ga-wrap"), { y: 16, autoAlpha: 0, duration: 0.5 })

        // Phase 1 → 65 (Wall)
        .to(s1, { autoAlpha: 1, y: 0, duration: 0.35 }, 0.05)
        .to(arcFill, { strokeDashoffset: len * (1 - 0.65), duration: 1.0 }, 0.05)
        .to(needle, { rotation: ANG(65), duration: 1.0 }, "<")
        .to(counter, {
          v: 65, duration: 1.0, ease: "none",
          onUpdate: () => (readout.textContent = Math.round(counter.v))
        }, "<")

        // Phase 2 → 100 (Unlocked)
        .to(s1, { autoAlpha: 0, y: -8, duration: 0.25 }, ">+0.05")
        .to(s2, { autoAlpha: 1, y: 0, duration: 0.35 }, "<")
        .to(arcFill, { strokeDashoffset: 0, duration: 1.2 }, ">-0.05")
        .to(needle, { rotation: ANG(100), duration: 1.2 }, "<")
        .to(counter, {
          v: 100, duration: 1.2, ease: "none",
          onUpdate: () => (readout.textContent = Math.round(counter.v))
        }, "<")
        .to(bottle, { autoAlpha: 1, scale: 1, duration: 0.55, ease: "back.out(2)" }, "<+0.1")
        .to(bottle, { y: -6, duration: 1.2, repeat: -1, yoyo: true, ease: "sine.inOut" }, "<");

      // 🔽 Play the timeline when the gauge scrolls into view
      ScrollTrigger.create({
        trigger: root,           // the <section class="ga"> …
        start: "top 80%",        // when top of section hits 80% of viewport
        once: true,              // fire just once
        onEnter: () => tl.play(0)
      });

      // optional: if images/fonts load late, ensure layout is correct
      const onLoad = () => ScrollTrigger.refresh();
      window.addEventListener("load", onLoad);
      return () => window.removeEventListener("load", onLoad);
    }, root);

    return () => ctx.revert();
  }, []);
*/
  



// add with your other refs

{/*const whyRef = React.useRef(null);

React.useLayoutEffect(() => {
  const root = whyRef.current;
  if (!root) return;

  const ctx = gsap.context(() => {
    const q = gsap.utils.selector(root);

    // initial states
    gsap.set(q(".wc-title"), { autoAlpha: 0, y: 20 });
    gsap.set(q(".wc-word"), { autoAlpha: 0, y: 28 });
    gsap.set(q(".wc-word > span"), { "--u": 0 }); // underline progress

    // play once when section enters
    ScrollTrigger.create({
      trigger: root,
      start: "top 80%",
      once: true,
      onEnter: () => {
        const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

        tl.to(q(".wc-title"), { autoAlpha: 1, y: 0, duration: 0.55 })
          // left
          .to(q(".w1"), { autoAlpha: 1, y: 0, duration: 0.45 }, "+=0.05")
          .to(q(".w1 > span"), { "--u": 1, duration: 0.45 }, "<")
          // center
          .to(q(".w2"), { autoAlpha: 1, y: 0, duration: 0.45 }, "+=0.12")
          .to(q(".w2 > span"), { "--u": 1, duration: 0.45 }, "<")
          // right
          .to(q(".w3"), { autoAlpha: 1, y: 0, duration: 0.45 }, "+=0.12")
          .to(q(".w3 > span"), { "--u": 1, duration: 0.45 }, "<");
      }
    });

    // safe refresh
    const onLoad = () => ScrollTrigger.refresh();
    window.addEventListener("load", onLoad);
    requestAnimationFrame(() => ScrollTrigger.refresh());
    return () => window.removeEventListener("load", onLoad);
  }, root);

  return () => ctx.revert();
}, []);

*/}

/*
useLayoutEffect(() => {
  const root = youRef.current;
  if (!root) return;

  const ctx = gsap.context(() => {
    // start states
    gsap.set(".yc2-card.full", { y: 24, opacity: 0, scale: 0.98 });
    gsap.set(".yc2-word", { yPercent: 40, opacity: 0 });
    gsap.utils.toArray(".yc2-underline path").forEach(p => {
      const len = p.getTotalLength();
      gsap.set(p, { strokeDasharray: len, strokeDashoffset: len });
    });

    // entrance
    const tl = gsap.timeline({
      scrollTrigger: { trigger: root, start: "top 75%", once: true },
      defaults: { ease: "power3.out" }
    });

    tl.to(".yc2-card.full", { y: 0, opacity: 1, scale: 1, duration: 0.7 })
      .to(".yc2-word", { yPercent: 0, opacity: 1, duration: 0.55, stagger: 0.06 }, "-=0.35")
      .to(".yc2-underline path", { strokeDashoffset: 0, duration: 0.9 }, "-=0.25");

    // ambient float for orbs
    gsap.to(".yc2 .orb.o1", { y: -10, repeat: -1, yoyo: true, duration: 3.2, ease: "sine.inOut" });
    gsap.to(".yc2 .orb.o2", { y: -14, repeat: -1, yoyo: true, duration: 2.6, ease: "sine.inOut", delay: .25 });
    gsap.to(".yc2 .orb.o3", { y: -12, repeat: -1, yoyo: true, duration: 2.8, ease: "sine.inOut", delay: .5 });

    // subtle velocity skew on the line for spice
    const proxy = { skew: 0 };
    const clamp = gsap.utils.clamp(-3, 3);
    ScrollTrigger.create({
      trigger: root,
      start: "top bottom",
      end: "bottom top",
      onUpdate: self => {
        const s = clamp(self.getVelocity() / -400);
        if (Math.abs(s) > Math.abs(proxy.skew)) {
          proxy.skew = s;
          //gsap.to(".yc2-lines", { skewY: proxy.skew, duration: 0.35, ease: "power3.out" });
          gsap.to(proxy, { skew: 0, duration: 0.6, ease: "power3.out" });
        }
      }
    });
  }, root);

  return () => ctx.revert();
}, []);
*/





  return (
    <div ref={root} className="page">
      {/* Nav 
      <header className="nav">
        <div className="brand-wrap">
          <Link to="/"><img className="brand-mark" src="/DopeLogo.png" alt="Dope Shot logo" /></Link>
          {/*<Link to="/" className="brand" aria-label="Dope Shot">Dope Shot</Link>)
        </div>
        <nav className="links">
          {/* Use Links so we stay in SPA land 
          <Link to="/#flavours">Product</Link>
          <Link to="/#why">Why Dope Shot</Link>
          <Link to="/#buy">Buy</Link>
          <Link to="/about">About</Link>
        </nav>
      </header>*/}
      <SiteNav />

      {/* Hero */}
      <section className="hero">
        <p className="hero-kicker"></p>

        <h1 className="hero-title">
          <span className="h-line l1">Not a Sports Drink</span>
          <span className="h-line l2">Not a Gel</span>
          <span className="h-line l3">THE NEW FUEL TYPE {/*Something Different*/}</span>
          <span className="h-logo-wrap">
            <img
              className="hero-logo"
              src="/StickerDopeShot.webp"
              width="1400"
              alt="Dope Shot"
            />
          </span>
        </h1>

        <p className="hero-sub" style={{textAlign:"center"}}>{/*FUEL LIKE NOTHING ELSE*/}<br/>  <div className="hero-cta">
 {/*} <a href="/" className="btn-shop">Fuel the difference</a> */}
   {/*<BuyButton
    product={{ name: "Dope Shot", price: 36, image: "/dopeshoot-model3.png" }}
     className="btn-shop"
    packSize={1}>Fuel the difference</BuyButton> */}
  
</div></p>
       
        {/*<div className="scroll-cue" aria-hidden>Scroll</div>*/}
      </section>


      {/* Pinned scrub + storyboard */}
      <section className="scrub" ref={pinSectionRef}>
        <div className="scrub-media" aria-label="Product video">
          <video
            ref={videoRef}
            className="video"
            preload="auto"
            playsInline
            muted
            src="/background3.mp4"
          />
          {!videoReady && <div className="video-fallback">Loading</div>}
          <div className="scrub-overlay" aria-hidden>
            <h2 className="scrub-text t-1">First of its kind <br/>ENDURANCE SHOT</h2>
            <h2 className="scrub-text t-2">1 bottle</h2>
            <h2 className="scrub-text t-3">1,200 calories</h2>
           <h2 className="scrub-text t-4">0 Excuses</h2>
          </div>
        </div>
      </section>

      {/* Marquee 
      <section className="marquee" aria-label="Key points">
        <div className="marquee-track">
          <span>Built to Sip</span>
          <span>1200 Calories</span>
          <span>No Excuses</span>
          <span>THE NEW FUEL TYPE</span>
          <span>Feel the Difference</span>
          <span>Made by an Athlete</span>
          <span>For Maximum Performance</span>
          <span>Built to Sip</span>
          <span>1200 Calories</span>
          <span>No Excuses</span>
          <span>THE NEW FUEL TYPE</span>
          <span>Feel the Difference</span>
          <span>Made by an Athlete</span>
          <span>For Maximum Performance</span>
        </div>
      </section>*/}




      {/* Stats 
      <section className="slice">
        <div className="container stats">
          <div className="stat">
            <div className="stat-num">1</div>
            <div className="stat-label">bottle</div>
          </div>
          <div className="stat">
            <div className="stat-num">1200</div>
            <div className="stat-label">calories</div>
          </div>
          <div className="stat">
            <div className="stat-num">0</div>
            <div className="stat-label">excuses</div>
          </div>
        </div>
      </section>*/}

      {/* Feature Swap 
      <section className="slice alt feature-swap" ref={fsRef} style={{paddingTop: "8px"}}>
        <div className="container fs-wrap">
          <aside className="fs-sticky">
            <p className="fs-kicker"></p>
            <h3 className="fs-title">Fuel Without the Bullsh*t</h3>
            <div className="fs-progress"><div className="fs-bar" /></div>
            <ul className="fs-list">
              <li className="fs-step"><strong>1200 Calories in One Bottle</strong><span>Stop stuffing 12 gels in your jersey.</span></li>
              <li className="fs-step"><strong>This is the first of its kind</strong><span>The shot that shows results.</span></li>
              <li className="fs-step"><strong>Unlock 100g/hour</strong><span>Unlock your potential through proper fuel.</span></li>
              <li className="fs-step"><strong>Get maximum performance no excuses</strong><span>Maximum output no excuses just ride.</span></li>
            </ul>
          </aside>
          <div className="fs-visuals">
            <img className="fs-img" src="/Bikemountain1.png" alt="Mix fast" />
            <img className="fs-img" src="/DSCF0037.JPG" alt="Steady focus" />
            <img className="fs-img" src="/Bikemountain2.png" alt="Low sugar" />
            <img className="fs-img" src="/DSCF0100.JPG" alt="Everyday use" />
          </div>
        </div>
      </section>*/}


      {/* SHOP — Dope Shot (video + product card) */}
      <section id="shop-dope-real" className="slice shop-dope-real" style={{paddingTop: "8px", paddingBottom: "8px"}}>
        <div className="container shop-wrap" ref={shopRef}>
          {/* Left: media */}
          <div className="shop-media">
            <div className="media-frame">
              <video
                ref={shopVideoRef}
                className="shop-video"
                src="/videobase7.mp4"
                muted
                playsInline
                loop
                preload="metadata"
                poster="/DSCF9477.webp"
              />
              <div className="media-gloss" aria-hidden />
               {/*<div className="dims-width" aria-hidden>12″</div>
              <div className="dims-height" aria-hidden>16″</div>
              <div className="dims-chip" role="note" aria-label="Bag dimensions 12 inches wide by 16 inches high by 5 inches deep">
              <span className="d-val">12″</span><span className="d-lab">W</span>
              <span className="d-x" aria-hidden>×</span>
              <span className="d-val">16″</span><span className="d-lab">H</span>
              <span className="d-x" aria-hidden>×</span>
              <span className="d-val">5″</span><span className="d-lab">D</span>
            </div>*/}
            </div>
            <div className="media-caption"></div>
          </div>

          {/* Right: product card 
          <aside className="shop-card">
            <p className="shop-kicker">Shop Dope Shot</p>
            <h3 className="shop-title">Built For Real Fuel</h3>
            <p className="shop-sub">The carb blend that lets you train harder, last longer, and recover faster.</p>

            <ul className="shop-features">
              <li className="fs-step"><strong>✓ 4-Carb Mix (MTC)</strong><span>Maltodextrin, Glucose, Fructose, Sucrose → 20–50% more carb absorption.</span></li>
              <li className="fs-step"><strong>✓ 100g+ Per Hour</strong><span>400 calories an hour, easy on the gut.</span></li>
              <li className="fs-step"><strong>✓ 1200 Calories, Zero Overload</strong><span>Low sweetness, high solubility, no crash.</span></li>
            </ul>

            <div className="shop-purchase">
             {/* <div className="shop-price">
                <span className="now">$36</span>
                <span className="unit">/ pouch</span>
              </div>*/}

              {/* Flavor/size sample controls (non-functional placeholders) 
              <div className="shop-options">
                <button className="opt active" aria-pressed="true">Berry</button>
                <button className="opt">Citrus</button>
                <button className="opt">Neutral</button>
              </div>

              <a href="/#buy" className="shop-btn" aria-label="Buy Dope Shot now">
                See How It Works
              </a>
              <p className="shop-note">Ships in 24–48h • 30-day guarantee</p>
            </div>
          </aside>*/}
          <aside className="shop-card proof">
            <h3 className="proof-title">
              <span>Dope Shot</span>
            </h3>

            <p className="proof-copy">
              The carb mix designed for serious training, racing, and recovery.
            </p>

            <ul className="proof-list">
              <li><i>✓</i><span><strong>1,200 Calories in One Bottle </strong><br/>Less issues with Food in pockets and multiple bottle set ups</span></li>
              <li><i>✓</i><span><strong>4-CARBOHYDRATES Formula </strong><br/>More carb absorption than single-source fuel</span></li>
              <li><i>✓</i><span><strong>Easiest Way to consume 400 Calories per Hour</strong><br/>Gut Friendly and Neutral Taste</span></li>
            </ul>

            {/*<a href="/" className="proof-btn">Buy now</a>*/}
             <BuyButton
    product={{ name: "Dope Shot", price: 36, image: "/dopeshoot-model3.webp" }}
     className="proof-btn"
    packSize={1}>BUY NOW</BuyButton>
          </aside>
        </div>
      </section>

      
         {/* BIG BREAK — centred tagline */}
      <section className="slice big-break"style={{paddingTop:"0px"}}>
        <div className="container breaker-wrap" style={{padding:"0"}}>
          <div className="breaker-rule"><span className="rule-inner" /></div>
          <h2 className="breaker-line" aria-label="Behind the lift">
            <span className="breaker-word" style={{"--d":"0s"}}>THE FUTURE OF </span>
            <span className="breaker-word" style={{"--d":"0.1s"}}>HIGH CALORIE </span>
            <span className="breaker-word" style={{"--d":"0.2s"}}>FUELING</span>
          </h2>
          <div className="breaker-center">
            <p className="breaker-tag"></p>
          </div>
          <div className="breaker-rule"><span className="rule-inner" /></div>
        </div>
      </section>
      
{/*<section id="why-complicate" className="slice why-compact" ref={whyRef} style={{paddingTop: "8px", paddingBottom: "8px"}}>
  <div className="container">
    <h3 className="wc-title">WHY COMPLICATE?</h3>

    <div className="wc-row">
      <h4 className="wc-word w1"><span>OUR PRODUCT</span></h4>
      <h4 className="wc-word w2"><span>ONE SOLUTION</span></h4>
      <h4 className="wc-word w3"><span>ALL THE FUEL<br/>YOU NEED</span></h4>
    </div>
  </div>
</section> */}


      {/* YOU-COMPLICATE — single sentence 
      <section className="slice you-complicate v2" ref={youRef}>
        <div className="container yc2">
          <article className="yc2-card full">
            <div className="yc2-lines">
              <span className="yc2-word">Little</span>
              <span className="yc2-word">consistent</span>
              <span className="yc2-word">shots,</span>
              <span className="yc2-word">much</span>
              <span className="yc2-word">better</span>
              <span className="yc2-word">than</span>
              <span className="yc2-word">big</span>
              <span className="yc2-word">gulps.</span>
            </div>
            <svg className="yc2-underline" viewBox="0 0 520 22" aria-hidden="true">
              <path d="M8 16 Q 260 4 512 16" />
            </svg>
          </article>

          {/* ambient bits 
          <div className="yc2-bg" aria-hidden="true">
            <span className="orb o1"></span>
            <span className="orb o2"></span>
            <span className="orb o3"></span>
          </div>
        </div>
      </section>*/}



      




         {/* Horizontal flavours rail 
      <section id="flavours" ref={hSectionRef} className="h-section">
        <div ref={hTrackRef} className="h-track">
          {[
           // { name: "Fuel like nothing else", img: "/Bikemountain9.png" },
           // { name: "Feel the difference", img: "/DSCF0380.jpg" },
           // { name: "Try the difference", img: "/Bikemountain7.png" },
           // { name: "For maximum performance", img: "/DSCF9022.JPG" },
            //{ name: "Dope Shot Lite", img: "https://images.unsplash.com/photo-1531171596281-8b5d26917d8b?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
            //{ name: "Dope Shot Extreme", img: "https://media.istockphoto.com/id/1368604167/photo/grape-soda-soft-drink-in-cups-with-ice.webp?a=1&b=1&s=612x612&w=0&k=20&c=9Yt4ILz-ZyFLolINNXkOKbS-9cfBMXJUXWYOGhbimgk=" } 
          ].map((f, i) => (
            <article className="h-card" key={i}>
              <div className="h-media">
                <img src={f.img} alt={f.name} />
                <div className="h-fade" />
              </div>
              <div className="h-meta">
                <h4>{f.name}</h4>
                 <BuyButton
                  product={{ name: "Dope Shot", price: 36, image: "/dopeshoot-model3.png" }}
                  className="buy-btn"
                  packSize={1}>Buy now</BuyButton>
                {/*<button className="buy-btn">Buy now</button>
              </div>
            </article>
          ))}
        </div>
      </section>*/}


          {/* ONE BOTTLE — scrollytelling
      <section className="one-bottle" ref={oneRef}>
        <div className="ob-bg">
          <span className="ob-ring" />
          <span className="ob-grain" />
        </div>

        <div className="ob-stage">
          {/* Panel container
          <div className="ob-panels">
            {/* 1 bottle 
            <div className="ob-panel ob-panel--bottle">
              <div className="ob-number" data-role="bottle">0 </div>
              <div className="ob-label">  &nbsp;BOTTLE</div>
            </div>

            {/* 1200 calories
            <div className="ob-panel ob-panel--calories">
              <div className="ob-number" data-role="calories">0 </div>
              <div className="ob-label">  &nbsp;CALORIES</div>
            </div>

            {/* 0 excuses 
            <div className="ob-panel ob-panel--excuses">
              <div className="ob-number" data-role="excuses">0 </div>
              <div className="ob-label">  &nbsp;EXCUSES</div>
            </div>

            {/* Tagline 
            <div className="ob-panel ob-panel--tag">
              <p className="ob-tag">A unique fuel for your maximum performance.</p>
            </div>
          </div>
        </div>
      </section> */}









      {/* Will put back */}

      {/* Sticky specs 
      <section className="slice specs" ref={specsRef} style={{paddingTop: "28px"}}>
        <div className="container specs-wrap">
          <aside className="specs-sticky">
            <p className="specs-kicker">Why Dope Shot</p>
            <h3 className="specs-title">Built for the grind</h3>
            <div className="specs-progress"><div className="specs-bar" style={{ width: `${(specIndex / 4) * 100}%` }} /></div>
            <p className="specs-note">Point {specIndex} of 4</p>
          </aside>
          <div className="specs-panels">
            <article className="spec-panel"><h4>The grind is real</h4><p>4am alarms. Long rides. Work, family, training stacked back-to-back. Your legs are empty but you still clip in. Because stopping isn’t an option.</p></article>
            <article className="spec-panel"><h4>The old stuff failed</h4><p>Coffee made you jitter. Energy drinks made you crash. Gels sat heavy and tore up your gut. When it mattered most, nothing lasted.</p></article>
            <article className="spec-panel"><h4>Built different</h4><p>Dope Shot fuels the fight. Smooth on your stomach. Packed with the calories you actually need. No fake crap. Just clean fire to keep you going.</p></article>
            <article className="spec-panel"><h4>This is the edge</h4><p>Every climb. Every session. Every race. Dope Shot keeps you locked in to hold the wheel, drop the pack, and still walk away human when it’s over.</p></article>
            {/*<article className="spec-panel"><h4>Quick hit</h4><p>Powder blends clean. Shake once, ride hard.</p></article>
            <article className="spec-panel"><h4>Sharp mind</h4><p>Locked in. No jitters. Just control.</p></article>
            <article className="spec-panel"><h4>Clean burn</h4><p>Sweet enough to like, light enough to last.</p></article>
            <article className="spec-panel"><h4>Any grind</h4><p>Intervals, race day, or weekend miles. Always on.</p></article>
          </div>
        </div>
      </section>*/}


      

      {/* BIG BREAK — centred tagline 
      <section className="slice big-break">
        <div className="container breaker-wrap">
          <div className="breaker-rule"><span className="rule-inner" /></div>
          <h2 className="breaker-line" aria-label="Behind the lift">
            <span className="breaker-word" style={{"--d":"0s"}}>Behind</span>
            <span className="breaker-word" style={{"--d":"0.1s"}}>the</span>
            <span className="breaker-word" style={{"--d":"0.2s"}}>Powder</span>
          </h2>
          <div className="breaker-center">
            <p className="breaker-tag"></p>
          </div>
          <div className="breaker-rule"><span className="rule-inner" /></div>
        </div>
      </section>



    {/* ABOUT-THAT (v4)
    <section id="about-that" className="slice about-that v4">
      <div className="container at4-wrap">
        {/* Collage (right on desktop, top on mobile) 
        <aside className="at4-collage" aria-label="Dope Shot story photos">
          <div className="at4-stage">
            <figure className="ph ph-a"><img src="/about-us1.png" alt="Early mornings" /></figure>
            {/*<figure className="ph ph-b"><img src="/Clycle.png" alt="Long days" /></figure>*/}
            {/*<figure className="ph ph-c"><img src="/cycling2.png" alt="Finding the mix" /></figure>*/}
            {/*<figure className="ph ph-d"><img src="/dopedrink9.png" alt="Crew on the move" /></figure>*/}
            {/*<figure className="ph ph-e"><img src="showcase2.png" alt="Training grind" /></figure>
            <span className="at4-glow" aria-hidden />
          </div>
        </aside>

        {/* Copy 
        <div className="at4-copy">
          <h3 className="at4-head">
            <span className="at4-line">Fuel Born From the Grind of Racing.</span>
          </h3>
          <br/>
          <p className="at4-body">
            <span className="at4-line">"As a Cat 1 cyclist and Elite Triathlete, I've spent years looking for the fuel with enough calories that i could carry with me for my long rides and races.  There was none, so i made it. Now i can pack 1 bottle with 1,200 calories and be good for a 3-5 hour ride with water and a few snacks in my pockets.  It is really freeing to know that you have the calories you need in that one bottle."</span>
             <br/>
             <p className="reveal-up" style={{fontStyle:"italic", fontFamily:"cursive"}}>— Norman, Founder</p>
            {/*<span className="at4-line">A story of grit, loss, and legacy.</span>
          </p>

          <div className="at4-rule"><span className="inner" /></div>

          <div className="at4-cta">
            <br/>
            <a href="/about" className="btn-shop">Read the full story →</a>
          </div>
        </div>
      </div>
    </section>*/}


      {/* Origin Story 
      <section className="slice alt origin" ref={storyRef}>
        <div className="container origin-wrap">
          <aside className="story-sticky">
            <div className="story-visual">
              <img className="story-img" src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?q=80&w=1600&auto=format&fit=crop" alt="Early mornings" />
              <img className="story-img" src="https://images.unsplash.com/photo-1483721310020-03333e577078?q=80&w=1600&auto=format&fit=crop" alt="Long days" />
              <img className="story-img" src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=1600&auto=format&fit=crop" alt="Finding the mix" />
              <img className="story-img" src="https://images.unsplash.com/photo-1553456558-aff63285bdd1?q=80&w=1600&auto=format&fit=crop" alt="Dope Shot is born" />
            </div>
          </aside>
          <div className="story-panels">
            <article className="story-step"><h4>The grind is real</h4><p>4am alarms. Long rides. Work, family, training stacked back-to-back. Your legs are empty but you still clip in. Because stopping isn’t an option.</p></article>
            <article className="story-step"><h4>The old stuff failed</h4><p>Coffee made you jitter. Energy drinks made you crash. Gels sat heavy and tore up your gut. When it mattered most, nothing lasted.</p></article>
            <article className="story-step"><h4>Built different</h4><p>Dope Shot fuels the fight. Smooth on your stomach. Packed with the calories you actually need. No fake crap. Just clean fire to keep you going.</p></article>
            <article className="story-step"><h4>This is the edge</h4><p>Every climb. Every session. Every race. Dope Shot keeps you locked in to hold the wheel, drop the pack, and still walk away human when it’s over.</p></article>
          </div>
        </div>
      </section>*/}



  
      {/* Image grid 
      <section className="grid">
        <article className="card">
          <img src="/Bikemountain6.png" alt="Gym bottle with drink" />
          <div className="card-meta">Sip It</div>
        </article>
        <article className="card">
          <img src="/DSCF9560.JPG" alt="Running at sunrise" />
          <div className="card-meta">Absorb It</div>
        </article>
        <article className="card">
          <img src="/Bikemountain8.png" alt="Cyclist on the road" />
          <div className="card-meta">Keep Moving</div>
        </article>
      </section>*/}

     
        
      {/* Will put back */}

      {/* Steps
      <section id="why" className="slice alt">
        <div className="container steps">
          <div className="step"><div className="step-num">1</div><h4 className="reveal-up">Scoop</h4><p className="reveal-up">Add one scoop to cold water.</p></div>
          <div className="step"><div className="step-num">2</div><h4 className="reveal-up">Shake</h4><p className="reveal-up">Ten seconds and it is clear.</p></div>
          <div className="step"><div className="step-num">3</div><h4 className="reveal-up">Go</h4><p className="reveal-up">Feel the lift. Keep the focus.</p></div>
        </div>
      </section> */}

      {/* Reviews 
      <section className="slice reviews" ref={revRef}>
        <div className="container" >
          <div className="rev-row">
            <div className="rev-track">
              <div className="review">“100 g carbs an hour.”</div>
              <div className="review">“Four carbs, one smooth ride.”</div>
              <div className="review">“1200 calories in one bottle.”</div>
              <div className="review">“Built to sip, not choke down.”</div>
              <div className="review">“Low sweetness.”</div>
            </div>
            <div className="rev-track clone" aria-hidden="true">
              <div className="review">“100 g carbs an hour.”</div>
              <div className="review">“Four carbs, one smooth ride.”</div>
              <div className="review">“1200 calories in one bottle.”</div>
              <div className="review">“Built to sip, not choke down.”</div>
              <div className="review">“Low sweetness.”</div>
            </div>
          </div>

          <div className="rev-row reverse">
            <div className="rev-track">
              <div className="review">“Made by an athlete for athletes.”</div>
              <div className="review">“Maximum performance is only achieved with proper fueling”</div>
                {/*<div className="review">“No junk. Just fuel.”</div>
              <div className="review">“Easy to consume 100 grams per hour.”</div>
              <div className="review">“Most of your fuel, one bottle.”</div>
            </div>
            <div className="rev-track clone" aria-hidden="true">
               <div className="review">“Made by an athlete for athletes.”</div>
               <div className="review">“Maximum performance is only achieved with proper fueling.”</div>
               {/* <div className="review">“No junk. Just fuel.”</div>
              <div className="review">“Easy to consume 100 grams per hour.”</div>
              {/*<div className="review">“Most of your fuel, one bottle.”</div>
            </div>
          </div>
        </div>
      </section>*/}


     
      {/* Will put back */}

      {/*Founder note & counters  
      <section className="slice founder">
        <div className="container founder-wrap">
          <div className="founder-note">
            <h3 className="reveal-up">Founder’s note</h3>
            <p className="reveal-up">
              “Dope Shot started as my answer to long install days and early opens.
              I wanted strong, steady energy that kept me present with clients,
              not buzzing, not flat. Now it powers our styling runs across the world. It is my daily edge.”
            </p>
            <p className="reveal-up">— The Owner</p>
          </div>
          <div className="owner-impact">
            <div className="impact-stat"><div className="impact-num" data-count="32">0</div><div className="impact-label">minutes saved per morning</div></div>
            <div className="impact-stat"><div className="impact-num" data-count="18">0</div><div className="impact-label">productive days</div></div>
            <div className="impact-stat"><div className="impact-num" data-count="1200">0</div><div className="impact-label">calories, 1 bottle</div></div>
          </div>
        </div>
      </section>

         {/* TRAIN YOUR GUT – ARC GAUGE 
      <section className="slice ga" ref={gaugeRef}>
        <div className="container ga-wrap">
          <div className="ga-copy">
            <p className="ga-kicker">Train Your Gut. Unlock Performance.</p>
            <h3 className="ga-title">Fuel smarter.Unlock more.</h3>
            <p className="ga-lede">
              Your gut can take <strong>100g carbs/hour</strong> — 
              <span className="ga-muted"> but only if you fuel it right.</span>
            </p>
            <p className="ga-body">
              Dope Shot makes it easy — <strong>1200 calories in one bottle</strong>.
              Simple to pace. Easy on your stomach.
            </p>
            <div className="ga-states">
              <div className="ga-state s1">One carb: <strong>65g/hour</strong> — <em>Wall</em>.</div>
              <div className="ga-state s2">Multiple carbs: <strong>100g/hour</strong> — <em>Unlocked</em>.</div>
            </div>
          </div>

          <div className="ga-card">
            <svg className="ga-svg" viewBox="0 0 320 200" aria-label="Carb intake gauge">
              <defs>
                <linearGradient id="ga-fill-grad" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#bfbfbf" stopOpacity="0.35" />
                  <stop offset="100%" stopColor="#ffffff" stopOpacity="0.95" />
                </linearGradient>
                <filter id="ga-glow" x="-50%" y="-50%" width="200%" height="200%">
                  <feGaussianBlur stdDeviation="4" result="b" />
                  <feMerge>
                    <feMergeNode in="b" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
              </defs>

              {/* Arc track & fill 
              <path
                id="ga-arc-track"
                d="M 40 160 A 120 120 0 0 1 280 160"
                fill="none"
                stroke="rgba(255,255,255,.14)"
                strokeWidth="10"
                strokeLinecap="round"
              />
              <path
                id="ga-arc-fill"
                d="M 40 160 A 120 120 0 0 1 280 160"
                fill="none"
                stroke="url(#ga-fill-grad)"
                strokeWidth="12"
                strokeLinecap="round"
              />

              {/* ticks 
              <g stroke="#fff" strokeWidth="2" strokeLinecap="round">
                {/** we position by rotation around (160,160) 
                <g className="ga-tick" data-pos="0"><line x1="160" y1="40" x2="160" y2="32" /></g>
                <g className="ga-tick" data-pos="25"><line x1="160" y1="40" x2="160" y2="34" /></g>
                <g className="ga-tick" data-pos="50"><line x1="160" y1="40" x2="160" y2="32" /></g>
                <g className="ga-tick" data-pos="65"><line x1="160" y1="40" x2="160" y2="34" /></g>
                <g className="ga-tick" data-pos="75"><line x1="160" y1="40" x2="160" y2="34" /></g>
                <g className="ga-tick" data-pos="100"><line x1="160" y1="40" x2="160" y2="32" /></g>
              </g>

              {/* labels 
              <g className="ga-labels" fill="#bdbdbd" fontSize="10" textAnchor="middle">
                <text className="ga-label" data-pos="0">0</text>
                <text className="ga-label" data-pos="25">25</text>
                <text className="ga-label" data-pos="50">50</text>
                <text className="ga-label" data-pos="65">65</text>
                <text className="ga-label" data-pos="75">75</text>
                <text className="ga-label" data-pos="100">100</text>
              </g>

              {/* needle 
              <g className="ga-needle">
                <line x1="160" y1="160" x2="160" y2="60" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
                <circle cx="160" cy="160" r="6" fill="#fff" />
              </g>

              {/* bottle (glows at 100) 
              <image
                className="ga-bottle"
                href="/StickerDopeShot.png"
                xlinkHref="/StickerDopeShot.png"
                width="40"
                height="40"
                x="0"
                y="0"
                filter="url(#ga-glow)"
                style={{ imageRendering: "crisp-edges" }}
              />

              {/* readout 
              <g transform="translate(160, 178)">
                <text className="ga-val" textAnchor="middle" fontSize="20" fontWeight="800" fill="#fff">0</text>
                <text x="42" y="0" textAnchor="start" fontSize="12" fill="#bdbdbd">g/hour</text>
              </g>
            </svg>
          </div>
        </div>
      </section>*/}


      {/* FAQ *
      <section className="slice alt faq">
        <div className="container">
          <h3 className="reveal-up">Questions</h3>
          <div className="faq-list">
            <div className="faq-item">
              <button className="faq-q" aria-expanded="false"><span className="faq-icon" aria-hidden="true">+</span>What is the calories per serve</button>
              <div className="faq-a"><p>400 mg per standard serve.</p></div>
            </div>
            <div className="faq-item">
              <button className="faq-q" aria-expanded="false"><span className="faq-icon" aria-hidden="true">+</span>Does it mix clear</button>
              <div className="faq-a"><p>Yes. Fine powder blends clear in cold water.</p></div>
            </div>
            <div className="faq-item">
              <button className="faq-q" aria-expanded="false"><span className="faq-icon" aria-hidden="true">+</span>Is there sugar</button>
              <div className="faq-a"><p>Yes. It has Low sugar with a strong taste.</p></div>
            </div>
            <div className="faq-item">
              <button className="faq-q" aria-expanded="false"><span className="faq-icon" aria-hidden="true">+</span>Can I take it daily</button>
              <div className="faq-a"><p>Yes. It is designed for regular use, always follow your own tolerance.</p></div>
            </div>
          </div>
        </div>
      </section>*/}

      {/* CTA */}
      <section id="buy" className="slice">
        <div className="container cta">
          <div>
            <h3 className="reveal-up">THE NEW FUEL TYPE</h3>
            <p className="reveal-up">Hit <span style={{fontWeight:"bold"}}>‘BUY NOW’</span> and experience the difference.</p>
          </div>
           <BuyButton
            product={{ name: "Dope Shot", price: 36, image: "/dopeshoot-model3.webp" }}
            className="cta-btn"
            packSize={1}>BUY NOW</BuyButton>
          {/*<a href="/" className="cta-btn">BUY NOW</a>*/}
        </div>
      </section>



    

      {/* Footer */}
      <footer className="site-footer">
        <div className="foot-inner">
          <Link to="/">Terms</Link>
          <Link to="/">Privacy</Link>
          <Link to="/">Support</Link>
        </div>
        <div className="foot-copy">© Dope Shot</div>
      </footer>
    </div>
  );
}

/* --------------------------- APP = ROUTER SHELL --------------------------- */
export default function App() {
  // Lazy import to avoid circular import issues if any
  const Success = React.lazy(() => import("./Success"));
  const Cancel = React.lazy(() => import("./Cancel"));
  return (
    <>
      <ScrollAndHash />
      <React.Suspense fallback={<div style={{padding:40}}>Loading…</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
         {/* <Route path="/about" element={<About />} />*/}
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ1 />} />
          <Route path="/science" element={<Science />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          {/*<Route path="/shop" element={<Shop />} /> */}
          {/* <Route path="*" element={<div style={{padding:40}}>Not found</div>} /> */}
        </Routes>
      </React.Suspense>
    </>
  );
}
